import { render, staticRenderFns } from "./change-information.vue?vue&type=template&id=3b278b59&scoped=true"
import script from "./change-information.vue?vue&type=script&lang=js"
export * from "./change-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b278b59",
  null
  
)

export default component.exports